import type { GridColDef } from "@mui/x-data-grid";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Tooltip from "@mui/material/Tooltip";

import { fData } from 'src/utils/format-number';
import { fDateTime } from 'src/utils/format-time';

import { Iconify } from "src/components/iconify";

export const getColumns = (setCurrentPath: (path: string) => void, handleFolderClick: (_prefix: string) => void): GridColDef[] => [
  {
    field: 'key',
    headerName: 'Name',
    flex: 1,
    renderCell: (params) => {
      const isFolder = params.row.isFolder;
      const name = params.row.key.split('/').pop() || params.row.key

      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Iconify icon={isFolder ? 'eva:folder-fill' : 'eva:file-fill'} />
          {isFolder ? (
            <Link
              component="button"
              variant="body2"
              onClick={() => {
                handleFolderClick(params.row.key);
                setCurrentPath(params.row.key);
              }}
              sx={{ textAlign: 'left', textDecoration: 'none' }}
            >
              {name}
            </Link>
          ) : (
            <Box
              component="span"
              sx={{
                cursor: 'default',
                '&:hover': {
                  color: 'primary.main',
                },
              }}
            >
              <Tooltip
                title={name}
                arrow
                placement="bottom-start"
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: 'grey.800',
                      color: 'common.white',
                      fontSize: '0.75rem',
                      maxWidth: 400,
                      wordBreak: 'break-all',
                      '& .MuiTooltip-arrow': {
                        color: 'grey.800',
                      },
                    },
                  },
                }}
              >
                <span>{name}</span>
              </Tooltip>
            </Box>
          )}
        </Box>
      );
    },
  },
  {
    field: 'size',
    headerName: 'Size',
    width: 120,
    renderCell: (params) => {
      if (params.row.isFolder) {
        return '-';
      }
      return <span>{fData(params.row.size)}</span>;
    },
  },
  {
    field: 'lastModified',
    headerName: 'Last Modified',
    width: 180,
    renderCell: (params) => (
      <Box sx={{ gap: 0.5, display: 'flex', flexDirection: 'column' }}>
        <span>{fDateTime(params.row.lastModified)}</span>
      </Box>
    ),
  },
];